import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';

export type AlertColor = 'danger' | 'error' | 'success' | 'warning' | 'info' | 'primary' | 'secondary' | '';

export type AlertPayload = {
  id: string;
  isAlert: boolean;
  alertMsg: string;
  alertColor: AlertColor;
};

const defaultAlert = (): AlertPayload => ({
  id: '',
  isAlert: false,
  alertMsg: '',
  alertColor: ''
});

@Module({ name: 'general' })
export default class General extends VuexModule {
  alert: AlertPayload = defaultAlert();

  isLoading = false;

  @Mutation
  mutateAlert(payload: AlertPayload) {
    this.alert = { ...payload };
  }

  @Action({ commit: 'mutateAlert', rawError: true })
  async ShowAlert(alert: AlertPayload) {
    return { ...alert };
  }

  @Action({ commit: 'mutateAlert', rawError: true })
  async CloseAlert() {
    return defaultAlert();
  }

  @Mutation
  setLoading(val: boolean) {
    this.isLoading = val;
  }

  @Action({ commit: 'setLoading', rawError: true })
  async toggleLoading(val: boolean) {
    return val;
  }
}
